import React, { memo, useCallback, useRef, useState } from 'react';
/** COMPONENTS */
import { IncidentInfoModal } from '../../../../components/Incidents/IncidentModals';
import { Container } from './IncidentWrapperUI';
import { Callout, DirectionalHint } from '@fluentui/react';
import { IIncident } from '../../interfaces';

interface IProps {
  incident: IIncident;
  children: any;
}

export default memo(function IncidentWrapper({ incident, children }: IProps) {
  const [isInfoPopupOpen, setInfoPopupOpen] = useState(false);

  const onContainerClick = useCallback(() => {
    setInfoPopupOpen(!isInfoPopupOpen);
  }, [isInfoPopupOpen]);

  const closePopup = useCallback(() => {
    setInfoPopupOpen(false);
  }, []);

  const containerRef = useRef<any>();
  return (
    <>
      {isInfoPopupOpen && (
        <Callout
          target={containerRef}
          directionalHint={DirectionalHint.rightCenter}
          onDismiss={closePopup}
        >
          <IncidentInfoModal
            dismiss={closePopup}
            currentIncident={incident}
            closeParentPopup={closePopup}
          />
        </Callout>
      )}
      <Container
        ref={containerRef}
        color={incident?.type?.color}
        onClick={onContainerClick}
      >
        {children}
      </Container>
    </>
  );
});
